/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Table_TypeInputs */

const en_work_order_publish_table_type = /** @type {(inputs: Work_Order_Publish_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const fr_work_order_publish_table_type = /** @type {(inputs: Work_Order_Publish_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_work_order_publish_table_type = /** @type {(inputs: Work_Order_Publish_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const it_work_order_publish_table_type = /** @type {(inputs: Work_Order_Publish_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const ru_work_order_publish_table_type = /** @type {(inputs: Work_Order_Publish_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const es_work_order_publish_table_type = /** @type {(inputs: Work_Order_Publish_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const zh_cn2_work_order_publish_table_type = /** @type {(inputs: Work_Order_Publish_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const ja_work_order_publish_table_type = /** @type {(inputs: Work_Order_Publish_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプ`)
};

const hi_work_order_publish_table_type = /** @type {(inputs: Work_Order_Publish_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार`)
};

const pt_pt2_work_order_publish_table_type = /** @type {(inputs: Work_Order_Publish_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Work_Order_Publish_Table_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_table_type = /** @type {((inputs?: Work_Order_Publish_Table_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Table_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_table_type(inputs)
	if (locale === "de") return de_work_order_publish_table_type(inputs)
	if (locale === "it") return it_work_order_publish_table_type(inputs)
	if (locale === "ru") return ru_work_order_publish_table_type(inputs)
	if (locale === "es") return es_work_order_publish_table_type(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_table_type(inputs)
	if (locale === "ja") return ja_work_order_publish_table_type(inputs)
	if (locale === "hi") return hi_work_order_publish_table_type(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_table_type(inputs)
	return en_work_order_publish_table_type(inputs)
});